import React from 'react';
import TablaPartidosBase from './TablaPartidosBase.js';
import ResultadoListaPartidos from '../consulta/ResultadoListaPartidos.js';
import { NombreEquipoCategoria, NombreEquipoTorneo } from '../funciones/FuncionesEquipo.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import styles from './TablaPartidosBase.module.css';

/**
 * Componente unificado para mostrar tablas de partidos (solo lectura)
 * Soporta diferentes vistas: etapa, equipo, fecha
 * Usa TablaPartidosBase para estructura consistente
 * NO muestra columna Zona (los partidos se muestran agrupados por zona)
 */
const TablaPartidos = (props) => {
  const {
    partidos = [],
    categoria,
    torneo,
    onPartidoElegido,
    mostrarOrdenPartido = false,
    tituloGrupo = null,
  } = props;

  if (!partidos || partidos.length === 0) {
    return null;
  }

  return (
    <TablaPartidosBase
      mostrarOrdenPartido={mostrarOrdenPartido}
      mostrarBotonesEdicion={false}
      tituloGrupo={tituloGrupo}
    >
      <tbody>
        {partidos.map((partido) => (
          <tr key={partido.id}>
            {mostrarOrdenPartido && (
              <td className={styles.ordenPartido}>{partido.ordenPartido || ''}</td>
            )}
            <td className={styles.fecha}>
              {FuncionesFecha.CamposToFechaCorta(
                partido.anioPartido,
                partido.mesPartido,
                partido.diaPartido
              )}
            </td>
            <td className={styles.equipoLocal}>
              {torneo
                ? NombreEquipoTorneo(partido.equipoLocal, torneo)
                : NombreEquipoCategoria(
                    partido.equipoLocal?.nombre,
                    partido.equipoLocal?.categoria,
                    categoria
                  )}
            </td>
            <td className={styles.resultado}>
              <ResultadoListaPartidos
                id={partido.id}
                onPartidoElegido={onPartidoElegido}
                local={partido.resultadoLocal}
                visitante={partido.resultadoVisitante}
              />
            </td>
            <td className={styles.equipoVisitante}>
              {torneo
                ? NombreEquipoTorneo(partido.equipoVisitante, torneo)
                : NombreEquipoCategoria(
                    partido.equipoVisitante?.nombre,
                    partido.equipoVisitante?.categoria,
                    categoria
                  )}
            </td>
          </tr>
        ))}
      </tbody>
    </TablaPartidosBase>
  );
};

export default TablaPartidos;
